module.exports = {"email":null,"phone":null,"username":null,"legal_name":null,"tax_profile":null,"base_color":null,"logo":null,"country":null,"district":null,"city":null,"zip_code":null,"line_1":null,"line_2":null,"line_3":null,"collectible":null}


//////////////////
// WEBPACK FOOTER
// ./src/redux/resources/account_profile.json
// module id = 931
// module chunks = 32